import React from 'react';
import { ReactElement } from "react";
import { appStyle } from '../AppStyle';
import packageJson from '../../package.json';

export default function AddFooter({
    children
}: {
    children: ReactElement;
}) {
    return (
        <>
            <div style={{ minHeight: `calc(100vh - ${appStyle.footerStyle.height})` }}>
                {children}
            </div>
            <footer style={appStyle.footerStyle}>
                <div style={{ float: 'left' }}>© 2020</div>
                <div style={{ float: 'right' }}>version {packageJson.version}</div>
            </footer>
        </>
    );
}
